import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/mobile-menu/categories/140-motos-novedades-cascos.svg")